import axios from "axios";
import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;
const apiCountryStateUrl = process.env.REACT_APP_COUNTRY_STATE_URL;
const pinUrl = process.env.REACT_APP_PIN_API;

export const requestAddressFromPin = async (pinCode) => {
  try {
    const response = await axios.get(`${pinUrl}/${pinCode}`);
    const responseData = response.data;
    return responseData;
  } catch (error) {}
};

//API to get Customer's Profile Details
export const getCustomerByCodeApi = async (ccode) => {
  const response = await axiosInstance.get(`${apiUrl}/api/customers/${ccode}/`);
  return response;
};

//API to Customer's Contact Person's Contact Details
export const getCustomerContactProfileData = async (contactCode) => {
  const response = await axiosInstance.get(
    `${apiUrl}/api/contact/${contactCode}/`,
  );
  return response;
};

export const getCountryState = async () => {
  const response = await axios.get(`${apiCountryStateUrl}`);
  return response.data;
};

// edit customer for profile
export const editCustApi = async (ccode, mydata) => {
  const response = await axiosInstance.put(
    `${apiUrl}/api/customer/edit/${ccode}/`,
    mydata,
  );
  return response;
};

//// maitri
export async function saveCustomer(formData) {
  const response = await axiosInstance.post(
    `${apiUrl}/api/save-customer/`,
    formData,
  );
  return response.data;
}

export async function getCustomerCode() {
  const response2 = await axiosInstance.get(`${apiUrl}/api/generate_code/`);
  return response2;
}

/// change this later
export async function customer_edit(custid, formData) {
  const response = await axiosInstance.put(
    `${apiUrl}/api/customer/edit/${custid}/`,
    formData,
  );
  return response.data;
}

/// arwa
export async function fetchCustomerData(cmpid) {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/get_customer/?companytransid=${cmpid}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching customer data:", error.message);
    throw error;
  }
}

export async function customer_delete(custid) {
  try {
    const response = await axiosInstance.delete(
      `${apiUrl}/api/customer/delete/${custid}/`,
      {
        data: { isdel: 1 },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during customer delete API call:", error);
    throw error;
  }
}

//  api for assigning projects
export async function getProjectOfCustApi(cmpid, cid) {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/category-subcategory-mapping/?companyid=${cmpid}&custid=${cid}`,
    );
    return response;
  } catch (error) {
    throw error;
    throw error;
  }
}

export async function getAllCatSubCatObjectApi(cmpid, cid) {
  try {
    const result = await axiosInstance.get(
      `${apiUrl}/api/get_categories_with_subcategories/?company_id=${cmpid}&customer_id=${cid}`,
    );
    // console.log(result);
    return result;
  } catch (error) {
    throw error;
  }
}

export async function addProjectsApi(data) {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/api/Save-category-subcategory-mapping/`,
      data,
    );
    return response;
  } catch (error) {
    throw error;
    throw error;
  }
}

export const fetchCustomerContacts = async () => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/customer-contact/list/`,
    );

    // Success validation
    if (response.status === 200 && Array.isArray(response.data)) {
      return {
        success: true,
        data: response.data,
        message: "Contacts fetched successfully",
      };
    }

    return {
      success: false,
      data: [],
      message: "Unexpected response format",
    };
  } catch (error) {
    return {
      success: false,
      data: [],
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch contacts",
    };
  }
};
export const fetchContactsByCustomerId = async (cmpid) => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/get-contacts-customer/${cmpid}/`,
    );

    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: "Contacts fetched successfully",
      };
    }

    return {
      success: false,
      data: [],
      message: "Unexpected response format",
    };
  } catch (error) {
    return {
      success: false,
      data: [],
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch contacts",
    };
  }
};
export const createCustomerContact = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "api/customer-contact/create/",
      payload,
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    const apiError = error?.response?.data;

    let message = "Failed to create contact";

    if (Array.isArray(apiError)) {
      message = apiError[0]; //  handle array
    } else if (typeof apiError === "string") {
      message = apiError;
    } else {
      message =
        apiError?.error || apiError?.message || "Failed to create contact";
    }

    return {
      success: false,
      message,
      status: error?.response?.status,
    };
  }
};

export const getCustomerContactCode = async () => {
  try {
    const response = await axiosInstance.get(
      "api/customer-contact/generate-code/",
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to generate contact code",
    };
  }
};

export const deleteCustomerContact = async (contact_id) => {
  try {
    const response = await axiosInstance.delete(
      `api/customer-contact/delete/${contact_id}/`,
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
      message: response?.data?.message || "Contact deleted successfully",
    };
  } catch (error) {
    console.error("Delete Customer Contact Error:", error);

    return {
      success: false,
      status: error?.response?.status,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to delete contact. Please try again.",
    };
  }
};

export const getContactById = async (contact_id) => {
  return await axiosInstance.get(`api/customer-contact/${contact_id}/`);
};

export const updateCustomerContact = async (contact_id, data) => {
  return await axiosInstance.put(
    `api/customer-contact/update/${contact_id}/`,
    data,
  );
};

export const updateContactLogo = async (contactlogo) => {
  try {
    const response = await axiosInstance.put("api/update_contact_logo/", {
      contactlogo: contactlogo,
    });

    // Success validation
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: "Contact logo updated successfully",
      };
    }

    return {
      success: false,
      data: null,
      message: "Unexpected response format",
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update contact logo",
    };
  }
};

export async function getCustomer() {
  const response2 = await axiosInstance.get(`${apiUrl}/api/get_customer/`);
  return response2;
}
